export const CHAR_LIMITS = {
	// About and Basic MAX Character
	about: {
		descMax: 45000,
		basicDescMax: 900,
		speakersLimit: 32767
	},
	// Ticket Section MAX Character
	ticket: {
		descMax: 5000,
		categoryNameMax: 250,
		categoryDescMax: 5000,
		maxTicketLimit: 20,
	},
	// Organizer Section MAX Character
	organizer: {
		descMax: 30000
	},
	// Speaker Section MAX Character
	speaker: {
		sectionTitleMax: 200,
		sectionDescMax: 2000,
		commonMax: 99,
		commonLess: 100,
		aboutMax: 30000
	},
	// Sponsors Section MAX Character
	sponsor: {
		sectionTitleMax: 200,
		sectionTitleLess: 26,
		sectionDescMax: 2000,
		nameMax: 128,
		nameLess: 129,
		urlMax: 128,
		urlLess: 129,
		categoryNameMax: 128,
		categoryNameLess: 129
	},
	// Workshop Section MAX Character
	workshop: {
		sectionTitleMax: 200,
		sectionTitleLess: 26,
		sectionDescMax: 2000,
		titleMax: 1000,
		descMax: 30000
	},
	floorPlans: {
		sectionTitleMax: 128,
		sectionDescMax: 1024,
		nameMax: 128
	},
	exhibitors: {
		sectionTitleMax: 200,
		sectionDescMax: 1024,
		sectionLocationMax: 100,
	},
	partners: {
		sectionTitleMax: 200,
		sectionDescMax: 1024,
	},
	attendee_app: {
		subDomain: 50,
		tagName: 200
	},
	category: {
		name: 200
	},
	entity: {
		name: 200,
		description: 2000,
		website: 500,
		boothNumber: 20,
		loactions: 100
	},
	point_of_contact: {
		name: 200,
		designation: 200,
		organization: 200,
	},
	representative: {
		name: 200,
		designation: 200,
		organization: 200,
	},
	custom_module: {
		module_name: 200,
		description: 1024,
		item_name: 200
	},
	filters: {
		name: 100
	},
	notifications: {
		notification_title_full_screen: 200,
		notification_message_full_screen: 1000,
		notification_title_tost: 100,
		notification_message_tost: 200,
		notification_call_to_action: 20
	},
	gallery: {
		gallery_page_title: 200,
		gallery_url: 50,
		gallery_page_description: 1000
	}
};


export const entityModule = {
	SPONSOR: 1,
	PARTNER: 2,
	EXHIBITOR: 3
}

export const categoryEntity = {
	SPONSOR: 1,
	SPEAKER: 2,
	TICKET: 3,
	GALLERY: 4,
	PARTNER: 5,
	EXHIBITOR: 6
}

export const MODULE_TYPE = {
	sponsors: 1,
	speakers: 2,
	exhibitors: 3,
	chat: 4,
	address: 5,
	network: 6,
	partners: 7,
	agenda: 8,
	document_links: 9,
	floor_plan: 10,
	people: 11,
	companies: 12,
	scan: 13,
	meeting: 14,
	photobooth: 15
}


export const MODULE_TYPE_LABEL = {
	sponsors: "Sponsors",
	speakers: "Speakers",
	exhibitors: "Exhibitors",
	chat: "Chat",
	address: "Address",
	network: "Network",
	partners: "Partners",
	agenda: "Agenda",
	document_links: "Document & URL",
	floor_plan: "Floor Plan",
	people: "People",
	companies: "Companies",
	scan: "Scan",
	meeting: "Meeting",
	photobooth: "Photo Booth"
};
export const eventPlan = {
	free: 1,
	lite: 2,
	silver: 3,
	gold: 4,
	custom: 5
}

export const ACTIONS = {
	// for modules
	MODULE_LIST: 'moduleList',
	ADD_MODULE: 'addModule',
	EDIT_MODULE: 'editModule',
	ADD_ITEM: 'addItem',
	EDIT_ITEM: 'editItem',

	//for notification
	NOTIFICATION_LIST: "NotificationLists",
	ADD_NOTIFICATION: "addNotification",
	EDIT_NOTIFICATION: "editNotification",
	VIEW_NOTIFICATION: "viewNotification",

	//for gallery
	LIST_OF_CATEGORY: "listOfCategory",
	CREATE_CATEGORY: "createCategory",
	EDIT_CATEGORY: "editCategory",
	DELETE_CATEGORY: "deleteCategory",
}

export const NOTIFICATION_TYPE = {
	FULL_SCREEN_NOTIFICATION: 1,
	TOAST_NOTIFICATION: 2
}

export const ITEM_TYPE = {
	DOCUMENT: 1,
	LINK: 2
}

export const phoneRegexByCountry = {
	US: /^[+]?1?\d{10}$/, // USA: +1XXXXXXXXXX or 10 digits
	CA: /^[+]?1?\d{10}$/, // Canada: Same as USA
	IN: /^[+]?91?\d{10}$/, // India: +91XXXXXXXXXX or 10 digits
	UK: /^[+]?44?\d{10}$/, // UK: +44XXXXXXXXXX or 10 digits
	AU: /^[+]?61?\d{9}$/, // Australia: +61XXXXXXXXX or 9 digits
	DE: /^[+]?49?\d{10,13}$/, // Germany: +49XXXXXXXXXX (10-13 digits)
	FR: /^[+]?33?\d{9}$/, // France: +33XXXXXXXXX (9 digits)
	IT: /^[+]?39?\d{10}$/, // Italy: +39XXXXXXXXXX (10 digits)
	BR: /^[+]?55?\d{10,11}$/, // Brazil: +55XXXXXXXXXX or +55XXXXXXXXXXX
	CN: /^[+]?86?\d{11}$/, // China: +86XXXXXXXXXXX (11 digits)
	JP: /^[+]?81?\d{10,11}$/, // Japan: +81XXXXXXXXXX (10-11 digits)
	MX: /^[+]?52?\d{10}$/, // Mexico: +52XXXXXXXXXX (10 digits)
	RU: /^[+]?7?\d{10}$/, // Russia: +7XXXXXXXXXX (10 digits)
	ZA: /^[+]?27?\d{9}$/, // South Africa: +27XXXXXXXXX (9 digits)
	NG: /^[+]?234?\d{10}$/, // Nigeria: +234XXXXXXXXXX (10 digits)
	PK: /^[+]?92?\d{10}$/, // Pakistan: +92XXXXXXXXXX (10 digits)
	BD: /^[+]?880?\d{10}$/, // Bangladesh: +880XXXXXXXXXX (10 digits)
	KR: /^[+]?82?\d{9,10}$/, // South Korea: +82XXXXXXXXX (9-10 digits)
	ES: /^[+]?34?\d{9}$/, // Spain: +34XXXXXXXXX (9 digits)
	NL: /^[+]?31?\d{9}$/, // Netherlands: +31XXXXXXXXX (9 digits)
	SE: /^[+]?46?\d{9,10}$/, // Sweden: +46XXXXXXXXX (9-10 digits)
	CH: /^[+]?41?\d{9}$/, // Switzerland: +41XXXXXXXXX (9 digits)
	BE: /^[+]?32?\d{9}$/, // Belgium: +32XXXXXXXXX (9 digits)
	SG: /^[+]?65?\d{8}$/, // Singapore: +65XXXXXXXX (8 digits)
	MY: /^[+]?60?\d{9,10}$/, // Malaysia: +60XXXXXXXXX (9-10 digits)
	PH: /^[+]?63?\d{10}$/, // Philippines: +63XXXXXXXXXX (10 digits)
	ID: /^[+]?62?\d{9,11}$/, // Indonesia: +62XXXXXXXXX (9-11 digits)
	VN: /^[+]?84?\d{9,10}$/, // Vietnam: +84XXXXXXXXX (9-10 digits)
	SA: /^[+]?966?\d{9}$/, // Saudi Arabia: +966XXXXXXXXX (9 digits)
	AE: /^[+]?971?\d{9}$/, // UAE: +971XXXXXXXXX (9 digits)
	EG: /^[+]?20?\d{10}$/, // Egypt: +20XXXXXXXXXX (10 digits)
	KE: /^[+]?254?\d{9}$/, // Kenya: +254XXXXXXXXX (9 digits)
	TZ: /^[+]?255?\d{9}$/, // Tanzania: +255XXXXXXXXX (9 digits)
	GH: /^[+]?233?\d{9}$/, // Ghana: +233XXXXXXXXX (9 digits)
	AR: /^[+]?54?\d{10}$/, // Argentina: +54XXXXXXXXXX (10 digits)
	CL: /^[+]?56?\d{9}$/, // Chile: +56XXXXXXXXX (9 digits)
	CO: /^[+]?57?\d{10}$/, // Colombia: +57XXXXXXXXXX (10 digits)
	PE: /^[+]?51?\d{9}$/, // Peru: +51XXXXXXXXX (9 digits)
	NZ: /^[+]?64?\d{9}$/, // New Zealand: +64XXXXXXXXX (9 digits)
	TR: /^[+]?90?\d{10}$/, // Turkey: +90XXXXXXXXXX (10 digits)
	IR: /^[+]?98?\d{10}$/, // Iran: +98XXXXXXXXXX (10 digits)
	TH: /^[+]?66?\d{9}$/, // Thailand: +66XXXXXXXXX (9 digits)
	// Add additional countries as needed
};